import { LoginTheme } from ".";

const theme: LoginTheme = {
  title: "light",
  colors: {
    primary: "rgb(0, 41, 81)",
    secondary: "rgb(0,86,154)",
    tertiary: "rgb(236, 133, 0)",
    background: "white",
    scrollBar: "#e0e0e0",
    text: "black",
    navBarIcons: "rgb(0, 41, 81)",
    gray: "#545454",
    error: "#e74c3c",
    success: "#46c17d"
  }
};

export default theme;
